<template>
  <div class="forms__field-wrapper" :class="extraClasses">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <p class="forms__help-text" v-if="helpText.length > 0">{{ helpText }}</p>
    <div class="input-wrapper" :class="{ 'error': showFormError,  'required': required }">
      <template v-if="staticLabel">
        {{ staticLabel }}
      </template>
      <input class="input"
        type="text"
        :placeholder="label"
        :id="id"
        :required="required"
        v-model="value"
        @blur="validateField"
      />
      <label class="floating-label" :for="id">{{ label }}</label>
      <p class="forms__error-message"
        v-t="'errors.required_field'"
        v-if="showFormError"
        role="alert"/>
    </div>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";
import { mapGetters, mapState } from "vuex";

export default {
  name: "input-text",
  mixins: [AbstractField],
  watch: {
    "$store.state.user.userLoggedIn": function (newValue, oldValue) {
      this.setDefaults();
    },
  },
  mounted() {
    if (this.user.userLoggedIn) {
      this.setDefaults();
    }
  },
  methods: {
    setDefaults() {
      if (this.fieldData.crm_id == "RegistrantFirstName") {
        this.value = this.user.userDetails.firstName;
      } else if (this.fieldData.crm_id == "RegistrantLastName") {
        this.value = this.user.userDetails.lastName;
      }
    },
  },
  computed: {
    mainEmailFieldAndLoggedIn() {
      // If the user is logged in, and this is the primary email address for registering
      // then disable the field
      if (this.user.userLoggedIn) {
        return true;
      } else {
        return false;
      }
    },
    ...mapState(["user"]),
    ...mapGetters(["isLoggedIn"]),
  },
};
</script>